import { Dialog } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';

//  TODO разобраться со структурой (feature / entity)
// eslint-disable-next-line boundaries/element-types
import { PledgeEstateForm } from 'features/PledgeEstateForm';

import { PledgeEstateTexts } from './PledgeEstate.texts';
import styles from './PledgeEstatePopup.module.scss';

interface IProps {
  isShowPopup: boolean;
  onClosePopup: () => void;
  onSubmit: (data: TPledgeEstateFields) => Promise<void>;
  isSubmitting?: boolean;
}

export const PledgeEstatePopup = (props: IProps) => {
  const { isShowPopup, onClosePopup, onSubmit, isSubmitting } = props;
  const isMobile = useIsMobile();

  return (
    <Dialog
      visible={isShowPopup || isSubmitting}
      closable
      onClose={onClosePopup}
      fullscreen={isMobile}
      className={styles.dialogPopup}
    >
      <Dialog.Header title={PledgeEstateTexts.popupHeader} />
      <Dialog.Content>
        <PledgeEstateForm
          submitButtonText={PledgeEstateTexts.submitButtonLabel}
          onFormSubmit={onSubmit}
          isLoading={isSubmitting}
        />
      </Dialog.Content>
    </Dialog>
  );
};
